const LOGO_URL =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="225" height="90" viewBox="0 0 225 90"><rect width="225" height="90" rx="10" fill="%23ffffff"/><text x="112.5" y="53" text-anchor="middle" font-family="Arial, sans-serif" font-size="24" font-weight="700" fill="%231c4b82">Termoplast</text></svg>';

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain() {
  return (
    <img
      src={LOGO_URL}
      alt="Termoplast"
      width="225"
      height="90"
      loading="eager"
      style={{ display: 'block', objectFit: 'contain', marginTop: '10px' }}
    />
  );
}
